import React from 'react';
import { Redirect } from 'react-router-dom';
import { DEFAULT_PATHS } from 'config';
import { GetEventJudgeStore } from 'SessionState/Judge/EventJudgeStore';

const JudgeEntryPage: React.FC = () => {
  const judgeStore = GetEventJudgeStore();

  judgeStore.hydrateJudgeFromSession();

  const judge = judgeStore.CurrentJudge;

  if (!judge) {
    return <Redirect to={DEFAULT_PATHS.JUDGELOGIN} />;
  }

  return (
    <Redirect
      to={`/judge/eventhome/${judge.id}/${judge.eventId}`}
    />
  );
};

export default JudgeEntryPage;